import { useState } from "react";
import ReactModal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { eiuHeader, eiuInputs } from "../Tabellen/ConstTabKopf/EiuKopf";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyModalButtons,  MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export default function EiuCreate({ instance, reloadData }) {
    const attributes = eiuHeader.filter(entry => eiuInputs.includes(entry.accessor));
    const [newEiu, setNewEiu] = useState(new MonitorApi.EisenbahninfraunternehmenCreate());
    const [showModal, setShowModal] = useState(false);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        setNewEiu(new MonitorApi.EisenbahninfraunternehmenCreate());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const changingInput = event => {
        event.preventDefault();
        setNewEiu(previous => ({ ...previous, [event.target.name]: event.target.value }))
    }

    const submitForm = event => {
        event.preventDefault();
        instance.createEiuEisenbahninfraunternehmenPost(newEiu, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                alert(`Neues Eisenbahninfrastrukturunternehmen ${data.name} hinzugefügt.\nMit id: ${data.id}`);
                closeModal();
                reloadData();
            }
        })
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neues Eisenbahninfrastrukturunternehmen</MyNewButton>

            <ReactModal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm} id="Eingabe">
                    <h3>Neues EIU:</h3>
                    {attributes.map((column, index) => {
                        return (
                            <MyModalContentRow key={index}>
                                {<label>{`${column.Header}: `}
                                    <MyModalContentTextInput name={column.accessor} onChange={changingInput} required={true} />
                                </label>}
                            </MyModalContentRow>
                        )
                    })}
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>
    )
}